import React, { Component } from 'react'
import { Field } from 'redux-form'
import Selector from './selector'

class TegSelectprInput extends Component {
  render() {
    if (this.props.source) {
      return <Field label={this.props.label} component={Selector} name={this.props.source} />
    } else {
      return <Selector {...this.props} />
    }
  }
}

export default TegSelectprInput
